module.exports = __webpack_public_path__ + "static/next-event-5b803b6e165ff95ccdc1bbef08c8f5fd.png";